import React, { useState } from 'react';
import {
	Typography,
	Box,
	Grid,
	TextField,
	Button,
	CircularProgress,
} from '@material-ui/core';
import {
	BLACK_COLOR,
	WHITE_COLOR,
	GRAY_HIGHLIGHT,
	DEBIT_RED,
	CREDIT_GREEN,
} from '../../constants/color';
import usersApi from '../../apis/usersApi';

export default function Broadcast({ handleClose }) {
	const [isSending, setIsSending] = useState(false);
	const [status, setStatus] = useState('');
	const [message, setMessage] = useState({
		subject: '',
		body: '',
		option: 'ALL',
		// option: 'SPECIFY',
		// phoneNumbers: [2348173088905],
	});
	const disabled = !message.subject || !message.body;

	const onSend = async (type= 'broadcast') => {
		if (disabled) return;
		setStatus('');
		setIsSending(true);
		try {
			type === 'sms' ? await usersApi.sendBulkSMS(message) : await usersApi.broadcast(message);
			setStatus('Broadcast sent successfully');
			setMessage({ ...message, subject: '', body: '' });
		} catch (error) {
			console.log(error);
			setStatus(
				'Error: There was an issue with your request, please try again'
			);
		} finally {
			setIsSending(false);
		}
	};

	return (
		<div>
			<Box
				display='flex'
				width={{ xs: '80vw', sm: '60vw', md: '50vw' }}
				fullWidth
				height={84}
				justifyContent='space-between'
				alignItems='flex-start'
			>
				<Typography
					variant='h5'
					style={{
						fontFamily: 'HelveticaNeue-Bold',
						marginTop: 10,
					}}
				>
					Create Broadcast
				</Typography>

				<Typography
					onClick={handleClose}
					style={{ cursor: 'pointer', color: GRAY_HIGHLIGHT }}
				>
					<span
						role='img'
						aria-label='close'
					>
						✕
					</span>
				</Typography>
			</Box>
			<>
				{status && (
					<Typography
						variant='subtitle2'
						style={{
							// fontFamily: "HelveticaNeue-Bold",
							// fontSize: 10,
							marginBottom: 40,
							color: status.toLowerCase().startsWith('error')
								? DEBIT_RED
								: CREDIT_GREEN,
						}}
					>
						{status}
					</Typography>
				)}
				<Box mb={2}>
					<Grid container>
						<Grid
							item
							xs={12}
						>
							<TextField
								type='text'
								label='Subject (For Broadcasts)'
								placeholder='e.g. '
								variant='outlined'
								size='small'
								fullWidth
								InputLabelProps={{
									shrink: false,
								}}
								value={message.subject}
								onChange={(e) => {
									setMessage({ ...message, subject: e.target.value });
								}}
							/>
						</Grid>
						<Grid
							item
							xs={12}
						>
							<TextField
								id='outlined-multiline-static'
								label='Content'
								multiline
								minRows='4'
								variant='outlined'
								fullWidth
								InputLabelProps={{
									shrink: false,
								}}
								value={message.body}
								onChange={(e) => {
									setMessage({ ...message, body: e.target.value });
								}}
							/>
						</Grid>
					</Grid>
				</Box>
				<Box
					display='flex'
					justifyContent='flex-end'
					style={{ gap: 40 }}
				>
					{isSending ? (
						<CircularProgress
							disableShrink
							size={20}
							color='inherit'
						/>
					) : (
						<>
							<Button
								variant='outlined'
								size='large'
								component='span'
								disableElevation
								disabled={disabled || isSending}
								style={{
									fontSize: 12,
									fontWeight: 'bold',
									// backgroundColor: BLACK_COLOR,
									// color: WHITE_COLOR,
									borderRadius: 25,
									paddingLeft: 35,
									paddingRight: 35,
									opacity: disabled ? 0.8 : 1,
								}}
								onClick={() => onSend('sms')}
							>
								<>Send as Bulk SMS</>
							</Button>
							<Button
								variant='contained'
								size='large'
								component='span'
								disableElevation
								disabled={disabled || isSending}
								style={{
									fontSize: 12,
									fontWeight: 'bold',
									backgroundColor: BLACK_COLOR,
									color: WHITE_COLOR,
									borderRadius: 25,
									paddingLeft: 35,
									paddingRight: 35,
									opacity: disabled ? 0.8 : 1,
								}}
								onClick={onSend}
							>
								<>Send Broadcast</>
							</Button>
						</>
					)}
				</Box>
			</>
		</div>
	);
}
